import { Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import DefaultHeading from '../../components/heading/DefaultHeading';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import Switch from "react-switch";
import "./manageDisplayCapture.css";
import { useNavigate } from 'react-router-dom';
import { openPopup } from '../../stateManagement/actions/popupActions';
import { updateFeatureMetadata, getFeatureMetadata, deleteFeatureMetadata, createFeatureMetadata } from './manageDisplayCaptureService';
import { Loader } from "../../components/loader/Loader";
import { ConfirmationPopUp } from "../../components/popup/confirmationPopUp";

const ManageDisplayCapture = () => {

    const navigate = useNavigate();
    const [searchText, setSearchText] = useState('');
    const [rowsData, setRowsData] = useState<Record<string, any>[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [openDeleteConfirmationModal, setOpenDeleteConfirmationModal] = useState(false);
    const [openStatusConfirmationModal, setOpenStatusConfirmationModal] = useState(false);
    const [idToBeDeleted, setIdToBeDeleted] = useState<string>('');
    const [rowToBeUpdated, setRowToBeUpdated] = useState<Record<string, any>>({});

    const handleToggle = async () => {
        rowToBeUpdated["activeStatus"] = rowToBeUpdated.activeStatus === "inactive" ? "active" : "inactive";
        await createFeatureMetadata(rowToBeUpdated).then(() => { setRowToBeUpdated({}) });
        // updateFeatureMetadata(row.campaign, row);
    };

    const columns: GridColDef[] = [
        { field: 'id', headerName: 'Image-ID', width: 240, headerClassName: "common_header", disableColumnMenu: true },
        { field: 'featureName', headerName: 'Image Name', width: 300, headerClassName: "common_header", disableColumnMenu: true },
        { field: 'featureDescription', headerName: 'Image Description', width: 300, headerClassName: "common_header", disableColumnMenu: true, sortable: false },
        {
            field: 'actions',
            headerName: 'UPDATE',
            width: 150,
            headerAlign: 'center',
            align: 'center',
            headerClassName: "common_header", disableColumnMenu: true, sortable: false,
            renderCell: (params) => (
                <Button variant="contained" size="small" color="primary" onClick={() => handleUpdate(params.row.id)} >UPDATE</Button>
            ),
        },
        {
            field: 'delete',
            headerName: 'DELETE',
            width: 150,
            headerAlign: 'center',
            align: 'center',
            headerClassName: "common_header", disableColumnMenu: true, sortable: false,
            renderCell: (params) => (
                <Button variant="contained" size="small" color="primary" onClick={() => { setOpenDeleteConfirmationModal(true); setIdToBeDeleted(params.row.id) }}>DELETE</Button>
            ),
        },
        {
            field: "activeStatus",
            headerName: "Active Status",
            minWidth: 90,
            maxWidth: 150,
            editable: true,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sortable: false,
            disableColumnMenu: true,
            headerClassName: "common_header",
            renderCell: (params) => {
                return (
                    <Switch
                        onChange={() => { setOpenStatusConfirmationModal(true); setRowToBeUpdated(params.row) }}
                        checked={params.row.activeStatus === "inactive" ? false : true}
                        offColor="#909090"
                        onColor="#24c6b1"
                        size={22}
                        handleDiameter={19}
                        uncheckedIcon={
                            <div className="unchecked-icon-status">INACTIVE</div>
                        }
                        checkedIcon={
                            <div className="checked-icon-status">ACTIVE</div>
                        }
                        height={23}
                        width={65}
                    />
                );
            },
        },
    ];

    const filteredData = rowsData?.filter((item) =>
        Object.values(item).some(
            (value) =>
                typeof value === 'string' && value.toLowerCase().includes(searchText.toLowerCase())
        )
    );

    const filterModel = {
        items: [
            { id: 1, field: 'id', operator: 'contains', value: searchText },
            { id: 2, field: 'featureName', operator: 'contains', value: searchText },
            { id: 3, field: 'featureDescription', operator: 'contains', value: searchText }
        ],

    };

    const handleCreate = () => {
        navigate(`form?type=create`);
    }

    const handleUpdate = (id: string) => {
        navigate(`form?type=edit&job=${id}`);
    }

    const handleDelete = async () => {
        try {
            await deleteFeatureMetadata(idToBeDeleted).then(() => {
                setRowsData((prevRows) => {
                    const filteredRows = prevRows?.filter((item) =>
                        Object.values(item).some(
                            (value) =>
                                typeof value === 'string' && value.toLowerCase().includes(searchText.toLowerCase())
                        )
                    );
                    return filteredRows.filter((row: any) => row.id !== idToBeDeleted) || [];
                });
                setIdToBeDeleted('');
            });
        } catch {
            openPopup("Error", "Something Went Wrong");
        }
    }

    useEffect(() => {
        const getAndSetFeatureMetadata = async () => {
            setLoading(true);
            try {
                let response = await getFeatureMetadata();
                setRowsData(response);
            } catch {
                openPopup("Error", "Something Went Wrong While Retriving Data");
            }
            finally {
                setLoading(false);
            }
        }
        getAndSetFeatureMetadata();
    }, []);

    return <div className="manage_display_container">
        {
            loading ? <Loader /> :
                <>
                    <ConfirmationPopUp message="Are you sure you want to delete ?"
                        openConfirmModal={openDeleteConfirmationModal}
                        setOpenConfirmModal={setOpenDeleteConfirmationModal}
                        successMethod={() => { handleDelete() }} />
                    <DefaultHeading heading='Image Report' children={
                        <div className="edit-search-btn">
                            <div className="search-field">
                                <input
                                    type="text"
                                    placeholder="Search"
                                    name="search"
                                    autoFocus
                                    className="search-input-field"
                                    value={searchText}
                                    onChange={(e) => {
                                        setSearchText(e.target.value);
                                    }}
                                />
                            </div>
                            <Button className="customCreateButton" variant="contained" onClick={handleCreate}>CREATE IMAGE</Button>
                        </div>
                    } showDefaultBackButton={true} />
                    <ConfirmationPopUp message="Are you sure you want to change the status ?"
                        openConfirmModal={openStatusConfirmationModal}
                        setOpenConfirmModal={setOpenStatusConfirmationModal}
                        successMethod={() => { handleToggle() }} />
                    <div className="image_report_table" style={{ height: 400 }}>
                        <DataGrid
                            rows={filteredData}
                            filterModel={filterModel}
                            columns={columns}
                        />
                    </div>
                </>
        }
    </div>
}

export default ManageDisplayCapture;
